import { Injectable, Inject } from '@angular/core';
import { IhmConfiguration, IHM_CONFIG } from '../ihm-configuration.model';

// @dynamic
@Injectable()
export class IhmConfigurationTestingService<T extends IhmConfiguration> {
  private configuration: any;

  constructor(@Inject(IHM_CONFIG) private config: T) {
    this.configuration = this.config;
  }

  public get(): T {
    return this.configuration as T;
  }
}
